var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a61c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#530e0a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-376 -501)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 90,
    height: 90,
    rx: 22,
    transform: "translate(376 501)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-191 -1951)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.683,330.885l-8.9,4.207a7.253,7.253,0,0,0-6.183-3.815l-8.22-.226a8.681,8.681,0,0,1-3.736-.965l-.836-.433a14.753,14.753,0,0,0-13.665.014l.052-1.895a1.137,1.137,0,0,0-1.105-1.168l-9.014-.248A1.136,1.136,0,0,0,.9,327.461L.36,347.241a1.137,1.137,0,0,0,1.105,1.168l9.014.248h.031a1.137,1.137,0,0,0,1.137-1.106l.026-.946,2.342-1.254a4.017,4.017,0,0,1,3-.328L31,348.948c.024.007.049.013.074.018a14.965,14.965,0,0,0,3.073.317,15.166,15.166,0,0,0,6.336-1.383,1.058,1.058,0,0,0,.141-.078l20.274-13.114a1.137,1.137,0,0,0,.372-1.514,5.742,5.742,0,0,0-7.583-2.31ZM2.664,346.168l.482-17.508,6.741.185L9.4,346.354Zm36.79-.3a12.888,12.888,0,0,1-7.881.88l-13.945-3.915a6.285,6.285,0,0,0-4.686.512l-1.2.641.32-11.641a12.5,12.5,0,0,1,12.693-.677l.836.433a10.979,10.979,0,0,0,4.719,1.219l8.22.226a4.986,4.986,0,0,1,4.738,3.973l-12.244-.338a1.137,1.137,0,1,0-.063,2.273l13.513.372h.032a1.137,1.137,0,0,0,1.136-1.106,7.214,7.214,0,0,0-.11-1.475l9.133-4.315.027-.013a3.473,3.473,0,0,1,3.927.55Zm0,0",
    transform: "translate(581.64 2178.608)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598.337 2465)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.019,19.909l2.228-2.228A10.356,10.356,0,0,0,21.6,3.035L3.036,21.6A10.356,10.356,0,0,0,17.682,36.246l2.228-2.228A10.355,10.355,0,1,0,34.019,19.909ZM18.567,28.923a10.334,10.334,0,0,0,.384,2.8l-2.9,2.9A8.055,8.055,0,0,1,4.663,23.227l8.4-8.4,7.712,7.712A10.305,10.305,0,0,0,18.567,28.923ZM27.773,36.9a8.055,8.055,0,0,1,0-15.945Zm-5.388-16-7.7-7.7,8.539-8.539A8.055,8.055,0,1,1,34.62,16.054l-2.9,2.9A10.347,10.347,0,0,0,22.385,20.9Zm7.689,16V20.951a8.055,8.055,0,0,1,0,15.945Z",
    transform: "translate(0 0.001)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfService);
export default __webpack_public_path__ + "static/media/SelfService.ddb973a68aa5ccb7138e3f0ca2ecb303.svg";
export { ForwardRef as ReactComponent };